export default {
feedback: {
  title: "فیڈ بیک",
  placeholder: "پیغام لکھیں ({ contentLen }/1000 حروف)",
  error: "یہ ایک ایرر میسج ہے",
  uploadLimit: "تصاویر اور ویڈیوز اپ لوڈ کی حد",
  send: "بھیجیں",
  tipTitle: "ہمارا تجربہ بہتر بنانے میں مدد کریں",
  desc1: "آپ کوئی بھی سوال بھیج سکتے ہیں، اور اگر منظور ہوا تو آپ کو ایک سرپرائز گفٹ ملے گا۔",
  desc2: "اگر ویب سائٹ کے ذریعے ممکن نہ ہو، تو آپ ہمیں ای میل بھی کر سکتے ہیں۔"
}
};
